import Images from './images';

export {
  Images,
};
